import { FormControlLabel, Radio } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getFormSpecialtiesDiagnosis } from "../../../../actions/forms";
import CustomDialog from "../../../commons/dialog/customDialog";
import FormikActions from "../../../commons/formik/formikActions";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikRadio from "../../../commons/formik/formikRadio";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";
import { StyledFlex } from "../../../styled/flex";
import { StyledEspecialidadAdd } from "../../../styled/form";

const validation = Yup.object({
  idEspecialidadDiagnosticoOms: Yup.string().required("Campo obligatorio"),
  atencion: Yup.string().required("Campo obligatorio"),
  turno: Yup.date()
    .nullable()
    .min(
      new Date(Date.now()),
      "La fecha del turno no puede ser menor a la fecha actual",
    )
    .typeError("Fecha inválida")
    .test({
      name: "FechaTurnoObligatorio",
      message: "Campo obligatorio",
      test: function (value) {
        return this.parent.atencion === "En este mismo centro" && !value
          ? false
          : true;
      },
    }),
  observaciones: Yup.string()
    .max(500, "El campo no puede superar los 500 caracteres")
    .nullable()
    .required("Campo obligatorio"),
});

const EspecialidadesAdd = ({
  especialidad,
  open,
  handleClose,
  handleSubmit,
  idArt,
}) => {
  const dispatch = useDispatch();
  const specialties = useSelector((state) => state.forms.specialtiesDiagnosis);

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Agregar especialidad continúa tratamiento</DialogTitle>
      <FormikForm
        initialValues={especialidad}
        validationSchema={validation}
        onSubmit={(values) => {
          handleSubmit(values);
        }}>
        {({ values, setFieldValue }) => (
          <Form>

            <DialogContent>
              <StyledFlex.ColumnContainer>
                <FormikAutocomplete
                  name="idEspecialidadDiagnosticoOms"
                  label="Especialidad *"
                  options={specialties.data}
                  getOptions={() =>
                    dispatch(getFormSpecialtiesDiagnosis(idArt))
                  }
                  labelOption={(option) =>
                    `${option.especialidad} - ${option.diagnostico}`
                  }
                  renderOption={(option) =>
                    `${option.especialidad} - ${option.diagnostico}`
                  }
                  filterOptions={(option) =>
                    option.especialidad + option.diagnostico
                  }
                />
                <StyledEspecialidadAdd.RowContainer>
                  <FormikRadio
                    name="atencion"
                    value={especialidad.atencion}
                    label="Atención"
                    sx={{ marginTop: 3 }}
                    callBack={(value) => {
                      if (value !== "En este mismo centro") {
                        setFieldValue("turno", null);
                      }
                    }}>
                    {["En este mismo centro", "En otro prestador"].map((o) => (
                      <FormControlLabel
                        value={o}
                        control={<Radio />}
                        label={o}
                        labelPlacement="end"
                        key={o}
                      />
                    ))}
                  </FormikRadio>
                  {values.atencion === "En este mismo centro" && (
                    <FormikDateTimePicker
                      name="turno"
                      sx={{ marginTop: 6 }}
                      label="Fecha Hora Turno *"
                      disablePast
                      autoComplete="off"
                    />
                  )}
                </StyledEspecialidadAdd.RowContainer>
                <FormikTextFieldSpeech
                  name="observaciones"
                  label="Observaciones *"
                  type="text"
                  sx={{ marginTop: 3 }}
                  multiline
                />
              </StyledFlex.ColumnContainer>
            </DialogContent>
            <DialogActions>
              <FormikActions handleCancel={handleClose} />
            </DialogActions>
          </Form>
        )}
      </FormikForm>
    </CustomDialog>
  );
};

export default EspecialidadesAdd;
